import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <CommentsSection />
        <IndexSection />
        <MediaSection />
        <RankingSection />
        <TopicsSection />
        <CarouselSection />
        <AboutSection />
        <FaqSection />
        <FeaturesSection />
        <CardsSection />
        <UpdatesSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}